<template>
  <div class="loading-box">
    <Spin :tip="showTip" :spinning="true" :delay="delay" />
  </div>
</template>

<script setup lang="ts">
import { Spin } from "ant-design-vue";
import { computed } from "vue";
import { i18n } from "../../../locales/index";
const { t } = i18n.global;

const props = defineProps({
  delay: {
    type: Number,
  },
  size: {
    type: String,
  },
  tip: {
    type: String,
  },
});

const showTip = computed(() => {
  if (props.tip) {
    return props.tip;
  } else {
    return t("common.Loading");
  }
});
</script>
<style scoped lang="less">
.loading-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(0 0 0 / 20%);
  z-index: 100;

  position: absolute;
  top: 0;
  left: 0;

  // :deep(.ant-spin-dot-item) {
  //   background-color: #FFF;
  // }

  // :deep(.ant-spin.ant-spin-show-text .ant-spin-text) {
  //   color: #FFF;
  // }
}
</style>
